import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import OfficeOriginForm from "./OfficeOriginForm";
import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useOfficeOrigin from "./hooks/useOfficeOrigin";
import useDeleteOfficeOrigin from "./hooks/useDeleteOfficeOrigin";
import useUpdateOfficeOrigin from "./hooks/useUpdateOfficeOrigin";
import {
  addStateOfficeOrigin,
  selectedRowsStateOfficeOrigin,
  setFilterTextOfficeOrigin,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../../components/tables/MaterialOfficeConfigTable";

const OfficeOriginTable = () => {
  //Hooks Call
  const { data, isFetching } = useOfficeOrigin();
  const { mutateAsync: UpdateOfficeOrigin } = useUpdateOfficeOrigin();
  const BulkDeleteEmploymentType = useDeleteOfficeOrigin();
  //Atoms Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateOfficeOrigin);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateOfficeOrigin
  );
  const [filterText, setFilterText] = useRecoilState(setFilterTextOfficeOrigin);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setOfficeOrigIsExistState] = useState(false);
  const [officeOrigDataIsChange, setOfficeOrigDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasOfficeOrigin, setHasOfficeOrigin] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [displayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const queryClient = useQueryClient();
  const [editRowData, setEditRowData] = useState();
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officeorigin_edit;
  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officeorigin_add;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officeorigin_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const defaultValues = {
    officeOriginId: 0,
    officeOriginName: "",
    isActive: true,
    createdBy: "",
    createdOn: null,
  };
  const [hideColumn, sethideColumn] = useState(false);
  const [officeOriginNewData, setOfficeOriginNewData] = useState([
    defaultValues,
  ]);
  const [officeOriginFilteredData, setOfficeOriginFilteredData] = useState([]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setOfficeOriginFilteredData(result);
          setOfficeOriginId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {
        //console.log("error " + error);
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setOfficeOrigIsExistState(false);
    setOfficeOrigDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setOfficeOrigDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? officeOriginNewData.map((x) => (x.isActive = true))
      : officeOriginNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setOfficeOrigIsExistState(false);
    setOfficeOrigDataIsChange(false);
    setEdit(true);
    inputvalue = inputvalue.trim();
    if (SourceType === "officeOrigin") {
      if (fieldName === "OfficeOriginName") {
        setOfficeOrigDataIsChange(true);
        officeOriginNewData.map((x) => (x.officeOriginName = inputvalue));
      }
      inputvalue === "" ? setHasOfficeOrigin(false) : setHasOfficeOrigin(true);
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.officeOriginId);
    setOfficeOrigDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEdit(true);
    setEditRowData({ ...rowData });
    officeOriginNewData.map((x) => (x.isActive = rowData.isActive));
    officeOriginNewData.map((x) => (x.officeOriginId = rowData.officeOriginId));
    officeOriginNewData.map(
      (x) => (x.officeOriginName = rowData.officeOriginName)
    );
    officeOriginNewData.map((x) => (x.createdOn = rowData.createdOn));
    officeOriginNewData.map((x) => (x.createdBy = rowData.createdBy));
  };

  //Save changes
  const handleSave = (officeOriginNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateOfficeOrigin(officeOriginNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else if (
            officeOriginNewData[0].officeOriginName ===
              editRowData.officeOriginName &&
            officeOriginNewData[0].isActive === editRowData.isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else {
            setOfficeOriginNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            setOfficeOrigDataIsChange(false);
            queryClient.invalidateQueries(["GetOfficeOrigin"]);
            toast.fire(
              "Success",
              "Office Origin Updated Successfully",
              "success"
            );
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Office Origin", "error");
          queryClient.invalidateQueries(["GetOfficeOrigin"]);
          setOpenModalEdit(false);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.officeOriginId);
    BulkDeleteEmploymentType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Office Origins" : "Office Origin"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Office Origin Name",
      field: "officeOriginName",
      customSort: (a, b) =>
        a.officeOriginName && b.officeOriginName
          ? a.officeOriginName.trim().localeCompare(b.officeOriginName.trim())
          : a.officeOriginName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Office Origin"
              defaultValue={rowData.officeOriginName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "officeOrigin",
                  "OfficeOriginName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.officeOriginName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : rowData.createdOn ? (
          new Date(rowData.createdOn).toLocaleDateString()
        ) : (
          ""
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : rowData.modifiedDate ? (
          new Date(rowData.modifiedDate).toLocaleDateString()
        ) : (
          ""
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              checked={checkStatus}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return rowData.officeOriginId === editRowId ? (
          <div className="flex place-content-center gap-2 ">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasOfficeOrigin || !officeOrigDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!hasOfficeOrigin || !officeOrigDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setOfficeOrigDataIsChange(false);
                setOfficeOrigIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            {userPermissions.includes(editPermission) ? (
              <EditButton
                disabled={disabledButton || selectedRows.length > 0}
                className={
                  disabledButton || selectedRows.length > 0
                    ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                    : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                }
                onClick={() => {
                  setDisabledButton(true);
                  setActionEditState(true);
                  handleEditButton(rowData);
                  sethideColumn(true);
                }}
              />
            ) : (
              ""
            )}
          </div>
        );
      },
    },
  ];

  //Filters
  const [officeOriginId, setOfficeOriginId] = useState("");
  useEffect(() => {
    if (filterText) {
      setOfficeOriginFilteredData(
        data?.filter((x) =>
          x.officeOriginName
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (officeOriginId?.includes(".")) {
      let officeOriginIds = officeOriginId.split(".");
      const officeOriginIdsArr = officeOriginIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        officeOriginIdsArr.includes(x.officeOriginId)
      );

      setOfficeOriginFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.officeOriginId === Number(officeOriginId)
      );
      setOfficeOriginFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase  ">
          {" "}
          {/* <h1> Office Origin</h1>{" "} */}
        </div>
      )}
      {/* <div className=""> */}
      {!actionAddState && (
        <>
          <div className="bg-white p-4 space-y-2">
            <div className="flex flex-row justify-between items-center ">
              <TableFilters
                filterText={setFilterText}
                moduleDetails="Office Origin Name"
                textInputName="OfficeOriginName"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>

              <div>
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    buttonText="New Office Origin"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div>
              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}
            </div>

            <div className="">
              <MaterialOfficeConfigTable
                columns={matColumns}
                data={
                  officeOriginFilteredData?.length > 0
                    ? officeOriginFilteredData
                    : data
                    ? filterText === ""
                      ? data
                      : officeOriginFilteredData
                    : []
                }
                options={{
                  toolbar: false,
                  showTitle: false,
                }}
                selection={
                  !actionEditState && userPermissions.includes(deletePermission)
                }
                setOpenModal={setOpenModalDelete}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                isDeactivate={true}
                isLoading={isFetching}
              />
            </div>
            {/* </div> */}
          </div>
          <ConfirmBoxModal
            ModalTitle="Update Office Origin"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              sethideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(officeOriginNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Office Origin"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {actionAddState && (
        <div className="p-4">
          <OfficeOriginForm />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default OfficeOriginTable;
